/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type DocumentProcessingReceiptOutcome =
    (typeof DocumentProcessingReceiptOutcome)[keyof typeof DocumentProcessingReceiptOutcome];

export const DocumentProcessingReceiptOutcome = {
    Completed: 'Completed',
    Partial: 'Partial',
    NoFindings: 'NoFindings',
    Failed: 'Failed',
    NotRequired: 'NotRequired',
} as const;
